import { ROLES } from '../../config/user'
import { useEffect, useState } from 'react'
import UserAppBar from './UserPanel/UserAppBar'
import WAIcon from '@material-ui/icons/WhatsApp'
import { ITemplate } from '../../types/templates'
import { makeStyles } from '@material-ui/core/styles'
import { useSession } from '../../context/SessionContext'
import TemplateItemTypes from './UserPanel/TemplateItemTypes'
import Alert, { ActionsOptType } from '../../components/Alert'
import SuperUserAppBar from './SuperUserPanel/SuperUserAppBar'
import TemplateItemTypesSU from './SuperUserPanel/TemplateItemTypes'
import TemplateItemDocumentType from './UserPanel/TemplateItemDocumentType'
import { getTemplatesType, getTemplatesActive } from '../../services/templates'
import TemplateItemDocumentTypeSU from './SuperUserPanel/TemplateItemDocumentType'
import { Button, Container, Grid, Typography, useTheme, TextField } from '@material-ui/core'
/* import { useHistory } from 'react-router' */
/* import TemplateItem from './UserPanel/TemplateItem' */

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addTemplate: {
    maxWidth: '60vw',
    marginBottom: '2vh',
  },
  flexContainer: { // barra de busqueda
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
    width: '100%'
  },
}))

/**
 * Custom `TemplateListTypes` component declaration.
 * This component is used to display template types and search bar
 * @param {String} copyWelcome
 * @return TemplateListTypes
*/
const TemplateListTypes = ({
  // setTemplate,
  copyWelcome,
}: {
  // setTemplate: (newState: any) => void
  copyWelcome: string
}): JSX.Element => {
  const classes = useStyles()
  const theme = useTheme()
  const { user } = useSession()
  const [templates, setTemplates] = useState<ITemplate[] | null>()
  const [templatesActive, setTemplatesActive] = useState<ITemplate[] | null>()
  const [templatesActiveFound, setTemplatesActiveFound] = useState<ITemplate[] | null>()
  const [wordSearch, setWordSearch] = useState<string>('')
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  
  //load type of templates 
  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await getTemplatesType()
      if (data) setTemplates(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!templates) {
      fetchData()
    }
  }, [])

  // load enabled templates 
  useEffect(() => {
    const fetchTemplatesActive = async () => {
      const { data, error } = await getTemplatesActive()
      if (data) setTemplatesActive(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!templatesActive) {
      fetchTemplatesActive()
    }
  }, [])

  /**
   * This method that finds the matches of the search with enabled templates
   * @Return {void}
  */
  const onChandlerText = (text: string) => {    
    setWordSearch(text)
    let matches:ITemplate[] | undefined = []
    if(wordSearch.length >= 0)
    {
        matches = templatesActive?.filter(temp => {
        const regex = new RegExp(`${text}`)
        return temp.name.toLowerCase().match(regex)
      })
      if(matches && matches.length > 0)
      {
        setTemplatesActiveFound(matches)
      }
      else
      {
        setAlertOptions({
          message:
            'No se encontró ningún documento con este nombre',
          open: true,
          type: 'info',
        })
        setTemplatesActiveFound([])
      }
    }
    else
    {
      setTemplatesActiveFound([])
    }
  }

  return (
    <>
      {user?.role === ROLES.SUPER_USER && (
        <SuperUserAppBar/>
      )}
      {user?.role === ROLES.USER && (
        <UserAppBar/>
      )}  
      <Container className={classes.cardGrid} maxWidth="md">
        <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '2rem', fontWeight: 'bold' }}
        >
          ¡Te damos la bienvenida a Justiexpress!
        </Typography>
        {/* {user?.role === ROLES.ADMIN && (
          <Button
            onClick={() => history.push({ pathname: '/docengine/editor' })}
            variant="contained"
            color="primary"
            className={classes.addTemplate}
          >
            Crear plantilla
          </Button>
        )} */}
        <Typography
          variant="body1"
          align="center"
          // color="textSecondary"
          // paragraph
          style={{ marginBottom: '10px', color: theme.palette.secondary.dark }}
        >
          {copyWelcome} Selecciona la plantilla que mejor se ajuste a tus necesidades y sigue las instrucciones para que tú mismo puedas generar y editar rápidamente documentos diseñados por abogados expertos.
        </Typography>

        <form // barra de busqueda
          className={classes.flexContainer}
          noValidate
          style={{ marginBottom: '30px'}} 
          /* onSubmit={handleSubmit} */
        >
        <TextField
          style={{ width: '100%', marginTop: '0.9vh' }}
          label="Buscador de documentos" 
          variant="outlined"
          type='text'
          autoFocus={true}
          onChange={event => onChandlerText(event.target.value.toLowerCase())}
          value={wordSearch}
        />
        {/* <Button
          style={{ marginLeft: '2.5vh', marginTop: '0.9vh' }}
          /* type="submit" *
          disabled={Object.keys(errors).length > 0}
          variant="contained"
          size= 'large'
          >
            Buscar
        </Button> */}
      </form>

        {/* show templates */}
        <Grid container justifyContent="center" spacing={4}>
          {templates && (!templatesActiveFound || wordSearch.length === 0 || templatesActiveFound.length === 0) ? (
            templates.map((template: ITemplate, index: number) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                {user?.role === ROLES.SUPER_USER && (
                  <TemplateItemTypesSU template={template} />
                )}
                {user?.role === ROLES.USER && (
                  <TemplateItemTypes template={template} />
                )}
              </Grid>
            ))
          ) : (
            <></>
          )}
        </Grid>

        {/* show templates found*/}
        <Grid container justifyContent="center" spacing={4} style={{marginTop: '1.5vh'}}>
          {templatesActiveFound && templatesActiveFound.length > 0 && wordSearch.length > 0 ? (
            templatesActiveFound.map((template: ITemplate, index: number) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                {user?.role === ROLES.SUPER_USER && (
                  <TemplateItemDocumentTypeSU template={template} />
                )}
                {user?.role === ROLES.USER && (
                  <TemplateItemDocumentType template={template} />
                )}
              </Grid>
            ))
          ) : (
            <></>
          )}
        </Grid>

      </Container>
      <Button
        variant="contained"
        onClick={() =>
          window.open(
            'https://api.whatsapp.com/send?phone=573185725324&text=Hola%21%20Quisiera%20informaci%C3%B3n.',
            '_blank'
          )
        }
        style={{
          backgroundColor: '#1BD741',
          color: 'white',
          top: 'auto',
          bottom: 30,
          left: 'auto',
          right: 65,
          position: 'fixed',
          borderRadius: 20,
          paddingRight: '0.5vh'
        }}
        startIcon={<WAIcon style={{ fontSize: '45px' }} />}
      >
      </Button>
    </>
  )
}

export default TemplateListTypes